export let sampledeptdata = [
    {
        "departmentId": 779,
        "departmentName": "Beverages",
        "color": "#9b5555"
    },
    {
        "departmentId": 778,
        "departmentName": "Cereal",
        "color": "#41bfc8"
    },
    {
        "departmentId": 777,
        "departmentName": "Foreign Foods",
        "color": "#f31616"
    },
    {
        "departmentId": 776,
        "departmentName": "Frozen Foods",
        "color": "#783b21"
    },
    {
        "departmentId": 775,
        "departmentName": "Stationery",
        "color": "#4cc6d6"
    },
    {
        "departmentId": 774,
        "departmentName": "Body Care",
        "color": "#86bf40"
    },
    {
        "departmentId": 773,
        "departmentName": "Kitchen Tools",
        "color": "#7b2424"
    },
    {
        "departmentId": 772,
        "departmentName": "Liquore",
        "color": "#bb2cce"
    }
];

export let samplecatarr = [
    {
        categoryId: '1',
        categoryName: 'Beverages',
    },
    {
        categoryId: '2',
        categoryName: 'Dry Food',
    },
    {
        categoryId: '3',
        categoryName: 'Sea Food',
    },
    {
        categoryId: '4',
        categoryName: 'Salted Meat',
    },
    {
        categoryId: '4',
        categoryName: 'Milk Products',
    },
];

export let sampledisplayunits = [
    {
        "fieldShelves": [
            {
                "width": 300,
                "height": 40,
                "uom": "cm",
                "gap": 5,
                "x": 0,
                "y": 0,
                "rank": 1,
                "shelfId": 1501,
                "reverseRowNumber": 3
            },
            {
                "width": 300,
                "height": 40,
                "uom": "cm",
                "gap": 5,
                "x": 0,
                "y": 97.8,
                "rank": 2,
                "shelfId": 1502,
                "reverseRowNumber": 2
            },
            {
                "width": 300,
                "height": 40,
                "uom": "cm",
                "gap": 5,
                "x": 0,
                "y": 195.6,
                "rank": 3,
                "shelfId": 1503,
                "reverseRowNumber": 1
            }
        ],
        "fieldName": "לְהַצִיגלְהַצִיג",
        "width": 300,
        "height": 135,
        "depth": 50,
        "uom": "cm",
        "fieldId": 176,
        "remark": ""
    },
    {
        "fieldShelves": [
            {
                "width": 1,
                "height": 0.2,
                "uom": "meters",
                "gap": 0.05,
                "x": 0,
                "y": 0,
                "rank": 1,
                "shelfId": 1238,
                "reverseRowNumber": 5
            },
            {
                "width": 1,
                "height": 0.5,
                "uom": "meters",
                "gap": 0.05,
                "x": 0,
                "y": 50,
                "rank": 2,
                "shelfId": 1239,
                "reverseRowNumber": 4
            },
            {
                "width": 1,
                "height": 0.5,
                "uom": "meters",
                "gap": 0.05,
                "x": 0,
                "y": 160,
                "rank": 3,
                "shelfId": 1240,
                "reverseRowNumber": 3
            },
            {
                "width": 1,
                "height": 0.3,
                "uom": "meters",
                "gap": 0.05,
                "x": 0,
                "y": 270,
                "rank": 4,
                "shelfId": 1241,
                "reverseRowNumber": 2
            },
            {
                "width": 1,
                "height": 0.2,
                "uom": "meters",
                "gap": 0.1,
                "x": 0,
                "y": 340,
                "rank": 5,
                "shelfId": 1242,
                "reverseRowNumber": 1
            }
        ],
        "fieldName": "SA-01-Field",
        "width": 1,
        "height": 2,
        "depth": 0.2,
        "uom": "meters",
        "fieldId": 142,
        "remark": "",
        "imageId": 13336,
        "fieldImgUrl": "https://producti0n-res.s3.eu-west-3.amazonaws.com/temp/MxwwtP3D4ONwrt4MGX5i3download.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIARRBCRW2FIEQDSZOR%2F20220429%2Feu-west-3%2Fs3%2Faws4_request&X-Amz-Date=20220429T034448Z&X-Amz-Expires=604800&X-Amz-Signature=3aef434472f4d4185815df9bcd09e95b27c6fe8b77dada9a937441464f5342e8&X-Amz-SignedHeaders=host"
    },
    {
        "fieldShelves": [
            {
                "width": 300,
                "height": 45,
                "uom": "cm",
                "gap": 5,
                "x": 0,
                "y": 0,
                "rank": 1,
                "shelfId": 401,
                "reverseRowNumber": 6
            },
            {
                "width": 300,
                "height": 25,
                "uom": "cm",
                "gap": 5,
                "x": 0,
                "y": 122.66666666666666,
                "rank": 2,
                "shelfId": 402,
                "reverseRowNumber": 5
            },
            {
                "width": 300,
                "height": 45,
                "uom": "cm",
                "gap": 5,
                "x": 0,
                "y": 196.26666666666665,
                "rank": 3,
                "shelfId": 403,
                "reverseRowNumber": 4
            },
            {
                "width": 300,
                "height": 25,
                "uom": "cm",
                "gap": 5,
                "x": 0,
                "y": 318.9333333333333,
                "rank": 4,
                "shelfId": 404,
                "reverseRowNumber": 3
            },
            {
                "width": 300,
                "height": 50,
                "uom": "cm",
                "gap": 5,
                "x": 0,
                "y": 392.5333333333333,
                "rank": 5,
                "shelfId": 405,
                "reverseRowNumber": 2
            },
            {
                "width": 300,
                "height": 30,
                "uom": "cm",
                "gap": 5,
                "x": 0,
                "y": 527.4666666666666,
                "rank": 6,
                "shelfId": 406,
                "reverseRowNumber": 1
            }
        ],
        "fieldName": "DU - 02",
        "width": 300,
        "height": 250,
        "depth": 50,
        "uom": "cm",
        "fieldId": 70,
        "remark": ""
    },
    {
        "fieldShelves": [
            {
                "width": 300,
                "height": 45,
                "uom": "cm",
                "gap": 5,
                "x": 0,
                "y": 0,
                "rank": 1,
                "shelfId": 396,
                "reverseRowNumber": 5
            },
            {
                "width": 300,
                "height": 45,
                "uom": "cm",
                "gap": 5,
                "x": 0,
                "y": 122.66666666666666,
                "rank": 2,
                "shelfId": 397,
                "reverseRowNumber": 4
            },
            {
                "width": 300,
                "height": 45,
                "uom": "cm",
                "gap": 5,
                "x": 0,
                "y": 245.3333333333333,
                "rank": 3,
                "shelfId": 398,
                "reverseRowNumber": 3
            },
            {
                "width": 300,
                "height": 45,
                "uom": "cm",
                "gap": 5,
                "x": 0,
                "y": 368,
                "rank": 4,
                "shelfId": 399,
                "reverseRowNumber": 2
            },
            {
                "width": 300,
                "height": 45,
                "uom": "cm",
                "gap": 5,
                "x": 0,
                "y": 490.6666666666666,
                "rank": 5,
                "shelfId": 400,
                "reverseRowNumber": 1
            }
        ],
        "fieldName": "DU - 01",
        "width": 300,
        "height": 250,
        "depth": 50,
        "uom": "cm",
        "fieldId": 69,
        "remark": ""
    }
]

export let samplesubcatarr = [
    {
        subCategoryId: '1',
        subCategoryName: 'Soft Drinks',
        color: "#AB46D2"
    },
    {
        subCategoryId: '2',
        subCategoryName: 'Alcohol Drinks',
        color: "#FF6FB5"
    },
    {
        subCategoryId: '3',
        subCategoryName: 'Energy Drinks',
        color: "#4D96FF"
    },
    {
        subCategoryId: '4',
        subCategoryName: 'Natural Drinks',
        color: "#6F69AC"
    },
    {
        subCategoryId: '5',
        subCategoryName: 'Hot Drinks',
        color: "#FB3640"
    },
];

export let samplebrandsarr = [
    {
        subCategoryId: '1',
        brandId: '1',
        brandName: 'Coca Cola',
        color: "#F47340"
    },
    {
        subCategoryId: '1',
        brandId: '2',
        brandName: 'Pepsi',
        color: "#FD6F96"
    },
    {
        subCategoryId: '2',
        brandId: '3',
        brandName: 'Smirnoff',
        color: "#3DB2FF"
    },
    {
        subCategoryId: '2',
        brandId: '4',
        brandName: 'Martini',
        color: "#890596"
    },
    {
        subCategoryId: '3',
        brandId: '5',
        brandName: 'Redbull',
        color: "#CE1F6A"
    },
    {
        subCategoryId: '3',
        brandId: '6',
        brandName: 'Monster',
        color: "#C15050"
    },
    {
        subCategoryId: '4',
        brandId: '7',
        brandName: 'Kool-Natural',
        color: "#59886B"
    },
    {
        subCategoryId: '4',
        brandId: '8',
        brandName: 'Nat-Fun',
        color: "#BC658D"
    },
    {
        subCategoryId: '5',
        brandId: '9',
        brandName: 'Ceylon-Tea',
        color: "#8D448B"
    },
    {
        subCategoryId: '5',
        brandId: '10',
        brandName: 'Nescafe',
        color: "#239F95"
    },
]

export let samplesupparr = [
    {
        supplierId: '1',
        supplierName: 'DAX-US distributors',
    },
    {
        supplierId: '2',
        supplierName: 'Ruby Rails distributors',
    },
]

export let samplesimulateobject = [
    {
        category_name: 'Cat 1',
        fields: [
            {
                fieldCount :2,
                shelf: [
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 0,
                        rank: 1,
                        id: 1899,
                        reverseRowNumber: 5,
                        brand: [
                            {
                                startx: 0,
                                uom: 'cm',
                                brandName: 'coke',
                                uuid: '001',
                                products: [
                                    {
                                        name: 'prod 1',
                                        width: 10,
                                        height: 20,
                                        uom: 'cm',
                                        qty: 5,
                                        startingPoint: 0,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/12312312312/nRvibXPdeg9E40aCjHxDa_W100_100.jpg',
                                    },
                                    {
                                        name: 'prod 2',
                                        width: 13,
                                        height: 20,
                                        uom: 'cm',
                                        qty: 3,
                                        startingPoint: 50,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/01010121021105210241/-7gj0VaCt2RQPc-B6E2yB_W100_100.png',
                                    },
                                ],
                            },
                            {
                                startx: 0,
                                uom: 'cm',
                                brand: 'pesi',
                                uuid: '001',
                                products: [
                                    {
                                        name: 'prod 11',
                                        width: 10,
                                        height: 20,
                                        uom: 'cm',
                                        qty: 2,
                                        startingPoint: 89,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/45615611051561165/RoBQ9GVONozxWqTuAqXNd_W100_100.png',
                                    },
                                    {
                                        name: 'prod 22',
                                        width: 10,
                                        height: 12,
                                        uom: 'cm',
                                        qty: 1,
                                        startingPoint: 109,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/12312312312/nRvibXPdeg9E40aCjHxDa_W100_100.jpg',
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 80,
                        rank: 2,
                        id: 1900,
                        reverseRowNumber: 4,
                        brand: [
                            {
                                startx: 0,
                                uom: 'cm',
                                brandName: 'coke',
                                uuid: '001',
                                products: [
                                    {
                                        name: 'prod 1',
                                        width: 10,
                                        height: 20,
                                        uom: 'cm',
                                        qty: 5,
                                        startingPoint: 0,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/45615611051561165/RoBQ9GVONozxWqTuAqXNd_W100_100.png',
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 160,
                        rank: 3,
                        id: 1901,
                        reverseRowNumber: 3,
                    },
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 240,
                        rank: 4,
                        id: 1902,
                        reverseRowNumber: 2,
                    },
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 320,
                        rank: 5,
                        id: 1903,
                        reverseRowNumber: 1,
                    },
                ],
                fieldName: 'Cereals 5',
                width: 125,
                height: 200,
                depth: 45,
                uom: 'cm',
                id: 38,
            },
            {
                fieldCount :1,
                shelf: [
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 0,
                        rank: 1,
                        id: 1899,
                        reverseRowNumber: 5,
                        brand: [
                            {
                                startx: 0,
                                uom: 'cm',
                                brandName: 'coke',
                                uuid: '001',
                                products: [
                                    {
                                        name: 'prod 1',
                                        width: 10,
                                        height: 20,
                                        uom: 'cm',
                                        qty: 5,
                                        startingPoint: 0,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/12312312312/nRvibXPdeg9E40aCjHxDa_W100_100.jpg',
                                    },
                                    {
                                        name: 'prod 2',
                                        width: 13,
                                        height: 20,
                                        uom: 'cm',
                                        qty: 3,
                                        startingPoint: 50,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/01010121021105210241/-7gj0VaCt2RQPc-B6E2yB_W100_100.png',
                                    },
                                ],
                            },
                            {
                                startx: 0,
                                uom: 'cm',
                                brand: 'pesi',
                                uuid: '001',
                                products: [
                                    {
                                        name: 'prod 11',
                                        width: 10,
                                        height: 20,
                                        uom: 'cm',
                                        qty: 2,
                                        startingPoint: 89,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/45615611051561165/RoBQ9GVONozxWqTuAqXNd_W100_100.png',
                                    },
                                    {
                                        name: 'prod 22',
                                        width: 10,
                                        height: 12,
                                        uom: 'cm',
                                        qty: 1,
                                        startingPoint: 109,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/12312312312/nRvibXPdeg9E40aCjHxDa_W100_100.jpg',
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 80,
                        rank: 2,
                        id: 1900,
                        reverseRowNumber: 4,
                        brand: [
                            {
                                startx: 0,
                                uom: 'cm',
                                brandName: 'coke',
                                uuid: '001',
                                products: [
                                    {
                                        name: 'prod 1',
                                        width: 10,
                                        height: 20,
                                        uom: 'cm',
                                        qty: 5,
                                        startingPoint: 0,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/45615611051561165/RoBQ9GVONozxWqTuAqXNd_W100_100.png',
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 160,
                        rank: 3,
                        id: 1901,
                        reverseRowNumber: 3,
                    },
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 240,
                        rank: 4,
                        id: 1902,
                        reverseRowNumber: 2,
                    },
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 320,
                        rank: 5,
                        id: 1903,
                        reverseRowNumber: 1,
                    },
                ],
                fieldName: 'Cereals 5',
                width: 125,
                height: 200,
                depth: 45,
                uom: 'cm',
                id: 38,
            },
            {
                shelf: [
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 0,
                        rank: 1,
                        id: 1899,
                        reverseRowNumber: 5,
                        brand: [
                            {
                                startx: 0,
                                uom: 'cm',
                                brandName: 'coke',
                                uuid: '001',
                                products: [
                                    {
                                        name: 'prod 1',
                                        width: 10,
                                        height: 20,
                                        uom: 'cm',
                                        qty: 5,
                                        startingPoint: 0,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/12312312312/nRvibXPdeg9E40aCjHxDa_W100_100.jpg',
                                    },
                                    {
                                        name: 'prod 2',
                                        width: 13,
                                        height: 20,
                                        uom: 'cm',
                                        qty: 3,
                                        startingPoint: 50,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/01010121021105210241/-7gj0VaCt2RQPc-B6E2yB_W100_100.png',
                                    },
                                ],
                            },
                            {
                                startx: 0,
                                uom: 'cm',
                                brand: 'pesi',
                                uuid: '001',
                                products: [
                                    {
                                        name: 'prod 11',
                                        width: 10,
                                        height: 20,
                                        uom: 'cm',
                                        qty: 2,
                                        startingPoint: 89,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/45615611051561165/RoBQ9GVONozxWqTuAqXNd_W100_100.png',
                                    },
                                    {
                                        name: 'prod 22',
                                        width: 10,
                                        height: 12,
                                        uom: 'cm',
                                        qty: 1,
                                        startingPoint: 109,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/12312312312/nRvibXPdeg9E40aCjHxDa_W100_100.jpg',
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 80,
                        rank: 2,
                        id: 1900,
                        reverseRowNumber: 4,
                        brand: [
                            {
                                startx: 0,
                                uom: 'cm',
                                brandName: 'coke',
                                uuid: '001',
                                products: [
                                    {
                                        name: 'prod 1',
                                        width: 10,
                                        height: 20,
                                        uom: 'cm',
                                        qty: 5,
                                        startingPoint: 0,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/45615611051561165/RoBQ9GVONozxWqTuAqXNd_W100_100.png',
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 160,
                        rank: 3,
                        id: 1901,
                        reverseRowNumber: 3,
                    },
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 240,
                        rank: 4,
                        id: 1902,
                        reverseRowNumber: 2,
                    },
                    {
                        width: 125,
                        height: 36,
                        uom: 'cm',
                        gap: 4,
                        x: 0,
                        y: 320,
                        rank: 5,
                        id: 1903,
                        reverseRowNumber: 1,
                    },
                ],
                fieldName: 'Cereals 5',
                width: 125,
                height: 200,
                depth: 45,
                uom: 'cm',
                id: 38,
            },
            
        ],
    },
    {
        category_name: 'Carbonated Drinks',
        fields: [
            {
                fieldCount :1,
                shelf: [
                    {
                        width: 1,
                        height: 0.3,
                        uom: 'meters',
                        gap: 0.05,
                        x: 0,
                        y: 0,
                        rank: 1,
                        id: 1238,
                        reverseRowNumber: 5,
                        brand: [
                            {
                                startx: 0,
                                uom: 'cm',
                                brandName: 'coke',
                                uuid: '001',
                                products: [
                                    {
                                        name: 'prod 1',
                                        width: 10,
                                        height: 20,
                                        uom: 'cm',
                                        qty: 5,
                                        startingPoint: 0,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/45615611051561165/RoBQ9GVONozxWqTuAqXNd_W100_100.png',
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        width: 1,
                        height: 0.7,
                        uom: 'meters',
                        gap: 0.05,
                        x: 0,
                        y: 50,
                        rank: 2,
                        id: 1239,
                        reverseRowNumber: 4,
                    },
                    {
                        width: 1,
                        height: 0.6,
                        uom: 'meters',
                        gap: 0.05,
                        x: 0,
                        y: 160,
                        rank: 3,
                        id: 1240,
                        reverseRowNumber: 3,
                    },
                    {
                        width: 1,
                        height: 0.4,
                        uom: 'meters',
                        gap: 0.05,
                        x: 0,
                        y: 270,
                        rank: 4,
                        id: 1241,
                        reverseRowNumber: 2,
                    },
                    {
                        width: 1,
                        height: 0.3,
                        uom: 'meters',
                        gap: 0.1,
                        x: 0,
                        y: 340,
                        rank: 5,
                        id: 1242,
                        reverseRowNumber: 1,
                    },
                ],
                fieldName: 'SA-01-Field',
                width: 1,
                height: 2.5,
                depth: 0.2,
                uom: 'meters',
                id: 142,
            },
            
            {
                fieldCount :1,
                shelf: [
                    {
                        width: 1,
                        height: 0.3,
                        uom: 'meters',
                        gap: 0.05,
                        x: 0,
                        y: 0,
                        rank: 1,
                        id: 1238,
                        reverseRowNumber: 5,
                        brand: [
                            {
                                startx: 0,
                                uom: 'cm',
                                brandName: 'coke',
                                uuid: '001',
                                products: [
                                    {
                                        name: 'prod 1',
                                        width: 10,
                                        height: 20,
                                        uom: 'cm',
                                        qty: 5,
                                        startingPoint: 0,
                                        imageUrl:
                                            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/45615611051561165/RoBQ9GVONozxWqTuAqXNd_W100_100.png',
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        width: 1,
                        height: 0.7,
                        uom: 'meters',
                        gap: 0.05,
                        x: 0,
                        y: 50,
                        rank: 2,
                        id: 1239,
                        reverseRowNumber: 4,
                    },
                    {
                        width: 1,
                        height: 0.6,
                        uom: 'meters',
                        gap: 0.05,
                        x: 0,
                        y: 160,
                        rank: 3,
                        id: 1240,
                        reverseRowNumber: 3,
                    },
                    {
                        width: 1,
                        height: 0.4,
                        uom: 'meters',
                        gap: 0.05,
                        x: 0,
                        y: 270,
                        rank: 4,
                        id: 1241,
                        reverseRowNumber: 2,
                    },
                    {
                        width: 1,
                        height: 0.3,
                        uom: 'meters',
                        gap: 0.1,
                        x: 0,
                        y: 340,
                        rank: 5,
                        id: 1242,
                        reverseRowNumber: 1,
                    },
                ],
                fieldName: 'SA-01-Field',
                width: 1,
                height: 2.5,
                depth: 0.2,
                uom: 'meters',
                id: 142,
            },
        ],
    },
    
]
export let samplesimdata = [
    {
        category_name: 'Cat 1',
        field_obj: {
            shelf: [
                {
                    width: 125,
                    height: 36,
                    uom: 'cm',
                    gap: 4,
                    x: 0,
                    y: 0,
                    rank: 1,
                    id: 1899,
                    reverseRowNumber: 5,
                },
                {
                    width: 125,
                    height: 36,
                    uom: 'cm',
                    gap: 4,
                    x: 0,
                    y: 80,
                    rank: 2,
                    id: 1900,
                    reverseRowNumber: 4,
                },
                {
                    width: 125,
                    height: 36,
                    uom: 'cm',
                    gap: 4,
                    x: 0,
                    y: 160,
                    rank: 3,
                    id: 1901,
                    reverseRowNumber: 3,
                },
                {
                    width: 125,
                    height: 36,
                    uom: 'cm',
                    gap: 4,
                    x: 0,
                    y: 240,
                    rank: 4,
                    id: 1902,
                    reverseRowNumber: 2,
                },
                {
                    width: 125,
                    height: 36,
                    uom: 'cm',
                    gap: 4,
                    x: 0,
                    y: 320,
                    rank: 5,
                    id: 1903,
                    reverseRowNumber: 1,
                },
            ],
            fieldName: 'Cereals 5',
            width: 125,
            height: 200,
            depth: 45,
            uom: 'cm',
            id: 38,
        },
        sim_field_qty: 2,
    },
    {
        category_name: 'Cat 2',
        field_obj: {
            shelf: [
                {
                    width: 1,
                    height: 0.3,
                    uom: 'meters',
                    gap: 0.05,
                    x: 0,
                    y: 0,
                    rank: 1,
                    id: 1238,
                    reverseRowNumber: 5,
                },
                {
                    width: 1,
                    height: 0.7,
                    uom: 'meters',
                    gap: 0.05,
                    x: 0,
                    y: 50,
                    rank: 2,
                    id: 1239,
                    reverseRowNumber: 4,
                },
                {
                    width: 1,
                    height: 0.6,
                    uom: 'meters',
                    gap: 0.05,
                    x: 0,
                    y: 160,
                    rank: 3,
                    id: 1240,
                    reverseRowNumber: 3,
                },
                {
                    width: 1,
                    height: 0.4,
                    uom: 'meters',
                    gap: 0.05,
                    x: 0,
                    y: 270,
                    rank: 4,
                    id: 1241,
                    reverseRowNumber: 2,
                },
                {
                    width: 1,
                    height: 0.3,
                    uom: 'meters',
                    gap: 0.1,
                    x: 0,
                    y: 340,
                    rank: 5,
                    id: 1242,
                    reverseRowNumber: 1,
                },
            ],
            fieldName: 'SA-01-Field',
            width: 1,
            height: 2.5,
            depth: 0.2,
            uom: 'meters',
            id: 142,
        },
        sim_field_qty: 2,
    },
]

export let products= [
    {
        name: 'prod 1',
        width: 10,
        height: 20,
        uom: 'cm',
        qty: 5,
        startingPoint: 0,
        imageUrl:
            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/12312312312/nRvibXPdeg9E40aCjHxDa_W100_100.jpg',
    },
    {
        name: 'prod 2',
        width: 13,
        height: 20,
        uom: 'cm',
        qty: 3,
        startingPoint: 50,
        imageUrl:
            'https://d3ginyfiwc1r8i.cloudfront.net/main/11/01010121021105210241/-7gj0VaCt2RQPc-B6E2yB_W100_100.png',
    },
    
]

export let simulationbackdto={
    departmentId: 10,
    departmentName: "Test Department",
    categoryList: [
      {
        category_name: 'Organic Drinks',
        categoryId: 10,
        supplierId: 21,
        supplierName: "Test supplier",
        fields: [
          {
            fieldCount: 2,
            shelf: [
              {
                width: 125,
                height: 45,
                uom: 'cm',
                gap: 5,
                x: 0,
                y: 0,
                rank: 1,
                id: 1899,
                reverseRowNumber: 5,
                
                brand: [
                  {
                    startx: 0,
                    uom: 'cm',
                    brandName: 'coke',
                    uuid: '001',
                    products: [
                      {
                        id:1,
                        name: 'prod 1',
                        width: 10,
                        height: 20,
                        uom: 'cm',
                        qty: 15,
                        startingPoint: 0,
                        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/11/45615611051561165/RoBQ9GVONozxWqTuAqXNd_W100_100.png',
                        // productLocations:[{x:22,y:3,isoverlapping:false,overlappingProduct:{x:2,y:3,id:-1}}]
                      },
                      {
                        id:2,
                        name: 'prod 2',
                        width: 13,
                        height: 20,
                        uom: 'cm',
                        qty: 3,
                        startingPoint: 50,
                        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/11/01010121021105210241/-7gj0VaCt2RQPc-B6E2yB_W100_100.png',
                        
                      },
                      
                    ],
                    
                  },
                  {
                    startx: 0,
                    uom: 'cm',
                    brandName: 'pesi',
                    uuid: '001',
                    products: [
                      {
                        id:4,
                        name: 'prod 11',
                        width: 20,
                        height: 10,
                        uom: 'cm',
                        qty: 2,
                        startingPoint: 89,
                        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/2/7290016096491/S2349aP148VRA0KDnOyxN_W100_100.jpg',
                        
                      },
                      
                    ],
                    
                  },
                  
                ],
                
              },
              {
                width: 125,
                height: 45,
                uom: 'cm',
                gap: 5,
                x: 0,
                y: 0,
                rank: 1,
                id: 1899,
                reverseRowNumber: 5,
                
                brand: [
                  {
                    startx: 0,
                    uom: 'cm',
                    brandName: 'coke',
                    uuid: '001',
                    products: [
                      {
                        id:1,
                        name: 'prod 1',
                        width: 10,
                        height: 20,
                        uom: 'cm',
                        qty: 15,
                        startingPoint: 0,
                        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/11/45615611051561165/RoBQ9GVONozxWqTuAqXNd_W100_100.png',
                        // productLocations:[{x:22,y:3,isoverlapping:false,overlappingProduct:{x:2,y:3,id:-1}}]
                      },
                      {
                        id:2,
                        name: 'prod 2',
                        width: 13,
                        height: 20,
                        uom: 'cm',
                        qty: 3,
                        startingPoint: 50,
                        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/11/01010121021105210241/-7gj0VaCt2RQPc-B6E2yB_W100_100.png',
                        
                      },
                      
                    ],
                    
                  },
                  {
                    startx: 0,
                    uom: 'cm',
                    brandName: 'pesi',
                    uuid: '001',
                    products: [
                      {
                        id:4,
                        name: 'prod 11',
                        width: 20,
                        height: 10,
                        uom: 'cm',
                        qty: 2,
                        startingPoint: 89,
                        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/2/7290016096491/S2349aP148VRA0KDnOyxN_W100_100.jpg',
                        
                      },
                      
                    ],
                    
                  },
                  
                ],
                
              },
              {
                width: 125,
                height: 45,
                uom: 'cm',
                gap: 5,
                x: 0,
                y: 0,
                rank: 1,
                id: 1899,
                reverseRowNumber: 5,
                
                brand: [
                  {
                    startx: 0,
                    uom: 'cm',
                    brandName: 'coke',
                    uuid: '001',
                    products: [
                      {
                        id:89,
                        name: 'prod 1',
                        width: 20,
                        height: 10,
                        uom: 'cm',
                        qty: 12,
                        startingPoint: 0,
                        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/2/7290015039246/238832_W100_100.jpg',
                        // productLocations:[{x:22,y:3,isoverlapping:false,overlappingProduct:{x:2,y:3,id:-1}}]
                      },
                      
                      
                    ],
                    
                  },
                  
                  
                ],
                
              },
              {
                width: 125,
                height: 45,
                uom: 'cm',
                gap: 5,
                x: 0,
                y: 0,
                rank: 1,
                id: 1899,
                reverseRowNumber: 5,
                
                brand: [
                  {
                    startx: 0,
                    uom: 'cm',
                    brandName: 'coke',
                    uuid: '001',
                    products: [
                      {
                        id:77,
                        name: 'prod 1',
                        width: 10,
                        height: 20,
                        uom: 'cm',
                        qty: 24,
                        startingPoint: 0,
                        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/2/7290017513485/805660_W100_100.jpg',
                        // productLocations:[{x:22,y:3,isoverlapping:false,overlappingProduct:{x:2,y:3,id:-1}}]
                      },
                    ],
                    
                  },
                  
                ],
                
              },
            ],
            fieldName: 'Cereals 5',
            width: 125,
            height: 200,
            depth: 45,
            uom: 'cm',
            id: 38,
            
          },  
        ],
        
      },
      {
        category_name: 'Carbonated Drinks',
        categoryId: 10,
        supplierId: -1,
        supplierName: "",
        fields: [
          {
            fieldCount: 1,
            shelf: [
              {
                width: 1,
                height: 0.575,
                uom: 'meters',
                gap: 0.05,
                x: 0,
                y: 0,
                rank: 1,
                id: 1238,
                reverseRowNumber: 5,
                brand: [
                  {
                    startx: 0,
                    uom: 'cm',
                    brandName: 'coke',
                    uuid: '001',
                    products: [
                      {
                        name: 'prod 1',
                        width: 10,
                        height: 15,
                        uom: 'cm',
                        qty: 9,
                        startingPoint: 0,
                        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/2/8690531100724/792817_W100_100.jpg',
                        
                      },
                      
                    ]
                  }
                ]
              },
              {
                width: 1,
                height: 0.575,
                uom: 'meters',
                gap: 0.05,
                x: 0,
                y: 0,
                rank: 1,
                id: 1238,
                reverseRowNumber: 5,
                brand: [
                  {
                    startx: 0,
                    uom: 'cm',
                    brandName: 'coke',
                    uuid: '001',
                    products: [
                      {
                        name: 'prod 1',
                        width: 10,
                        height: 15,
                        uom: 'cm',
                        qty: 9,
                        startingPoint: 0,
                        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/2/8690531100724/792817_W100_100.jpg',
                        
                      },
                      
                    ]
                  }
                ]
              },
              {
                width: 1,
                height: 0.575,
                uom: 'meters',
                gap: 0.05,
                x: 0,
                y: 0,
                rank: 1,
                id: 1238,
                reverseRowNumber: 5,
                brand: [
                  {
                    startx: 0,
                    uom: 'cm',
                    brandName: 'coke',
                    uuid: '001',
                    products: [
                      {
                        name: 'prod 1',
                        width: 10,
                        height: 20,
                        uom: 'cm',
                        qty: 9,
                        startingPoint: 0,
                        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/1/7290104570162/801172_W100_100.jpg',
                        
                      },
                      
                    ]
                  }
                ]
              },
              {
                width: 1,
                height: 0.575,
                uom: 'meters',
                gap: 0.05,
                x: 0,
                y: 0,
                rank: 1,
                id: 1238,
                reverseRowNumber: 5,
                brand: [
                  {
                    startx: 0,
                    uom: 'cm',
                    brandName: 'coke',
                    uuid: '001',
                    products: [
                      {
                        name: 'prod 1',
                        width: 10,
                        height: 20,
                        uom: 'cm',
                        qty: 9,
                        startingPoint: 0,
                        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/1/7290104570162/801172_W100_100.jpg',
                        
                      },
                      
                    ]
                  }
                ]
              }, 
            ],
            fieldName: 'SA-01-Field',
            width: 1,
            height: 2.5,
            depth: 0.2,
            uom: 'meters',
            id: 142,
            
          }, 
        ],
        
      }
    ]
  }
export let samplebrandprods = [
    {
        id: 1909,
        barcode: "45615611051561165",
        brandName: 'Coca Cola',
        productName: 'Coca Cola',
        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/11/6534554/EZct14O4et202wrFBoVme_W100_100.jpeg',
        is_ontop: true,
        is_mvp: false,
        spf: 37,
        percentage: 54,
        req_percentage: 80
    },
    {
        id: 1909,
        barcode: "100000001",
        brandName: 'Coca Cola',
        productName: 'Fanta',
        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/11/6534554/EZct14O4et202wrFBoVme_W100_100.jpeg',
        is_ontop: true,
        is_mvp: false,
        spf: 24,
        percentage: 65,
        req_percentage: 94
    },
    {
        id: 1909,
        barcode: "12312312312",
        brandName: 'Coca Cola',
        productName: 'Sprite',
        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/11/6534554/EZct14O4et202wrFBoVme_W100_100.jpeg',
        is_ontop: true,
        is_mvp: false,
        spf: 41,
        percentage: 45,
        req_percentage: 55
    },
    {
        id: 1909,
        barcode: "01010121021105210241",
        brandName: 'Coca Cola',
        productName: 'Coca Cola',
        imageUrl: 'https://d3ginyfiwc1r8i.cloudfront.net/main/11/6534554/EZct14O4et202wrFBoVme_W100_100.jpeg',
        is_ontop: false,
        is_mvp: true,
        spf: 51,
        percentage: 69,
        req_percentage: 75
    }
];

export let sampleprodtags = [
    {
        tagId: 1,
        tagName: "Beverage"
    },
    {
        tagId: 2,
        tagName: "Soft Drink",
        isAdded: true
    },
    {
        tagId: 3,
        tagName: "Soda Drink"
    },
    {
        tagId: 4,
        tagName: "Discounted"
    },
    {
        tagId: 5,
        tagName: "Classic",
        isAdded: true
    },
    {
        tagId: 6,
        tagName: "Sugar-Contain",
        isAdded: true
    },
    {
        tagId: 7,
        tagName: "Urban"
    },
    {
        tagId: 8,
        tagName: "Mixture"
    }
];

export let newsimulationbackdto={
  "department": {
      "department_id": 10,
      "department_name": "Test Department"
  },
  "categoryList": [
      {
          "category_name": "Cat 1",
          "category_id": 10,
          "supplier_obj": {
              "supplierId": 21,
              "supplierName": "Test supplier"
          },
          "field": {
              "fieldName": "Cereals 5",
              "width": 1500,
              "height": 200,
              "depth": 45,
              "uom": "cm",
              "fieldId": 38,
              "shelf": [
                  {
                      "width": 1500,
                      "height": 45,
                      "uom": "cm",
                      "gap": 5,
                      "x": 0,
                      "y": 0,
                      "rank": 1,
                      "id": 1899,
                      "reverseRowNumber": 4,
                      "brand": [
                          {
                              "startx": 0,
                              "width": 748,
                              "uom": "cm",
                              "brandName": "coke",
                              "uuid": "001",
                              "mpHasCatHasSubCatHasBrandId": 1,
                              "mpHasCatHasSubCatHasBrandHasRankId": 1,
                              "products": [
                                {
                                    "id": 70,
                                    "name": "",
                                    "width": 10,
                                    "height": 0,
                                    "uom": "cm",
                                    "qty": 0,
                                    "startingPoint": 0,
                                    "generatedSpace": 400,
                                    "mpHasCatId": 1,
                                    "mpHasCatHasSubCatId": 1,
                                    "mpHasCatHasSubCatHasBrandId": 1,
                                    "imageUrl":null,
                                    "isEmptySpace" : true
                                },
                                  {
                                      "id": 1,
                                      "name": "prod 1",
                                      "width": 10,
                                      "height": 20,
                                      "uom": "cm",
                                      "qty": 4,
                                      "startingPoint": 0,
                                      "generatedSpace": 400,
                                      "mpHasCatId": 1,
                                      "mpHasCatHasSubCatId": 1,
                                      "mpHasCatHasSubCatHasBrandId": 1,
                                      "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/11/12312312312/nRvibXPdeg9E40aCjHxDa_W100_100.jpg"
                                  },
                                  {
                                      "id": 2,
                                      "name": "prod 2",
                                      "width": 13,
                                      "height": 20,
                                      "uom": "cm",
                                      "qty": 26,
                                      "startingPoint": 400,
                                      "generatedSpace": 338,
                                      "mpHasCatId": 1,
                                      "mpHasCatHasSubCatId": 1,
                                      "mpHasCatHasSubCatHasBrandId": 1,
                                      "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/11/01010121021105210241/-7gj0VaCt2RQPc-B6E2yB_W100_100.png"
                                  }
                              ]
                          },
                          {
                              "startx": 758,
                              "width": 740,
                              "uom": "cm",
                              "brandName": "pesi",
                              "uuid": "002",
                              "mpHasCatHasSubCatHasBrandId": 2,
                              "mpHasCatHasSubCatHasBrandHasRankId": 2,
                              "products": [
                                  {
                                      "id": 4,
                                      "name": "prod 11",
                                      "width": 20,
                                      "height": 10,
                                      "uom": "cm",
                                      "qty": 37,
                                      "startingPoint": 738,
                                      "generatedSpace": 740,
                                      "mpHasCatId": 1,
                                      "mpHasCatHasSubCatId": 1,
                                      "mpHasCatHasSubCatHasBrandId": 2,
                                      "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/11/45615611051561165/RoBQ9GVONozxWqTuAqXNd_W100_100.png"
                                  }
                              ]
                          }
                      ]
                  },
                  {
                      "width": 1500,
                      "height": 45,
                      "uom": "cm",
                      "gap": 5,
                      "x": 0,
                      "y": 0,
                      "rank": 2,
                      "id": 1899,
                      "reverseRowNumber": 3,
                      "brand": [
                          {
                              "startx": 0,
                              "width": 738,
                              "uom": "cm",
                              "brandName": "coke",
                              "uuid": "001",
                              "mpHasCatHasSubCatHasBrandId": 1,
                              "mpHasCatHasSubCatHasBrandHasRankId": 3,
                              "products": [
                                  {
                                      "id": 1,
                                      "name": "prod 1",
                                      "width": 10,
                                      "height": 20,
                                      "uom": "cm",
                                      "qty": 4,
                                      "startingPoint": 0,
                                      "generatedSpace": 400,
                                      "mpHasCatId": 1,
                                      "mpHasCatHasSubCatId": 1,
                                      "mpHasCatHasSubCatHasBrandId": 1,
                                      "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/11/45615611051561165/RoBQ9GVONozxWqTuAqXNd_W100_100.png"
                                  },
                                  {
                                      "id": 2,
                                      "name": "prod 2",
                                      "width": 13,
                                      "height": 20,
                                      "uom": "cm",
                                      "qty": 2,
                                      "startingPoint": 400,
                                      "generatedSpace": 338,
                                      "mpHasCatId": 1,
                                      "mpHasCatHasSubCatId": 1,
                                      "mpHasCatHasSubCatHasBrandId": 1,
                                      "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/11/01010121021105210241/-7gj0VaCt2RQPc-B6E2yB_W100_100.png"
                                  }
                              ]
                          },
                          {
                              "startx": 738,
                              "width": 750,
                              "uom": "cm",
                              "brandName": "pesi",
                              "uuid": "002",
                              "mpHasCatHasSubCatHasBrandId": 2,
                              "mpHasCatHasSubCatHasBrandHasRankId": 4,
                              "products": [
                                  {
                                      "id": 4,
                                      "name": "prod 11",
                                      "width": 20,
                                      "height": 10,
                                      "uom": "cm",
                                      "qty": 37,
                                      "startingPoint": 738,
                                      "generatedSpace": 740,
                                      "mpHasCatId": 1,
                                      "mpHasCatHasSubCatId": 1,
                                      "mpHasCatHasSubCatHasBrandId": 2,
                                      "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/2/7290016096491/S2349aP148VRA0KDnOyxN_W100_100.jpg"
                                  }
                              ]
                          }
                      ]
                  },
                  {
                      "width": 1500,
                      "height": 45,
                      "uom": "cm",
                      "gap": 5,
                      "x": 0,
                      "y": 0,
                      "rank": 1,
                      "id": 1899,
                      "reverseRowNumber": 2,
                      "brand": [
                          {
                              "startx": 0,
                              "width": 1500,
                              "uom": "cm",
                              "brandName": "coke",
                              "uuid": "001",
                              "mpHasCatHasSubCatHasBrandId": 1,
                              "mpHasCatHasSubCatHasBrandHasRankId": 5,
                              "products": [
                                  {
                                      "id": 1,
                                      "name": "prod 1",
                                      "width": 20,
                                      "height": 10,
                                      "uom": "cm",
                                      "qty": 75,
                                      "startingPoint": 0,
                                      "generatedSpace": 1500,
                                      "mpHasCatId": 1,
                                      "mpHasCatHasSubCatId": 1,
                                      "mpHasCatHasSubCatHasBrandId": 1,
                                      "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/2/7290015039246/238832_W100_100.jpg"
                                  }
                              ]
                          }
                      ]
                  },
                  {
                      "width": 1500,
                      "height": 45,
                      "uom": "cm",
                      "gap": 5,
                      "x": 0,
                      "y": 0,
                      "rank": 1,
                      "id": 1899,
                      "reverseRowNumber": 1,
                      "brand": [
                          {
                              "startx": 0,
                              "width": 1500,
                              "uom": "cm",
                              "brandName": "coke",
                              "uuid": "001",
                              "mpHasCatHasSubCatHasBrandId": 1,
                              "mpHasCatHasSubCatHasBrandHasRankId": 6,
                              "products": [
                                  {
                                      "id": 1,
                                      "name": "prod 1",
                                      "width": 10,
                                      "height": 20,
                                      "uom": "cm",
                                      "qty": 75,
                                      "startingPoint": 0,
                                      "generatedSpace": 1500,
                                      "mpHasCatId": 1,
                                      "mpHasCatHasSubCatId": 1,
                                      "mpHasCatHasSubCatHasBrandId": 1,
                                      "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/2/7290017513485/805660_W100_100.jpg"
                                  }
                              ]
                          }
                      ]
                  }
              ],
              "fieldCount": 3
          }
      },
      {
          "category_name": "Carbonated Drinks",
          "category_id": 10,
          "supplier_obj": {
              "supplierId": -1,
              "supplierName": ""
          },
          "field": {
              "fieldName": "SA-01-Field",
              "width": 1,
              "height": 2.5,
              "depth": 0.2,
              "uom": "meters",
              "fieldId": 142,
              "shelf": [
                  {
                      "width": 1,
                      "height": 0.575,
                      "uom": "meters",
                      "gap": 0.05,
                      "x": 0,
                      "y": 0,
                      "rank": 1,
                      "id": 1238,
                      "reverseRowNumber": 4,
                      "brand": [
                          {
                              "startx": 0,
                              "width": 100,
                              "uom": "cm",
                              "brandName": "coke",
                              "uuid": "001",
                              "mpHasCatHasSubCatHasBrandId": 1,
                              "mpHasCatHasSubCatHasBrandHasRankId": 7,
                              "products": [
                                  {
                                    "id": 12,
                                      "name": "prod 1",
                                      "width": 10,
                                      "height": 15,
                                      "uom": "cm",
                                      "qty": 10,
                                      "startingPoint": 0,
                                      "generatedSpace": 100,
                                      "mpHasCatId": 2,
                                      "mpHasCatHasSubCatId": 1,
                                      "mpHasCatHasSubCatHasBrandId": 1,
                                      "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/2/8690531100724/792817_W100_100.jpg"
                                  }
                              ]
                          }
                      ]
                  },
                  {
                      "width": 1,
                      "height": 0.575,
                      "uom": "meters",
                      "gap": 0.05,
                      "x": 0,
                      "y": 0,
                      "rank": 1,
                      "id": 1238,
                      "reverseRowNumber": 3,
                      "brand": [
                          {
                              "startx": 0,
                              "width": 100,
                              "uom": "cm",
                              "brandName": "coke",
                              "uuid": "001",
                              "mpHasCatHasSubCatHasBrandId": 1,
                              "mpHasCatHasSubCatHasBrandHasRankId": 8,
                              "products": [
                                  {
                                    "id": 12,
                                      "name": "prod 1",
                                      "width": 10,
                                      "height": 15,
                                      "uom": "cm",
                                      "qty": 10,
                                      "startingPoint": 0,
                                      "generatedSpace": 100,
                                      "mpHasCatId": 2,
                                      "mpHasCatHasSubCatId": 1,
                                      "mpHasCatHasSubCatHasBrandId": 1,
                                      "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/2/8690531100724/792817_W100_100.jpg"
                                  }
                              ]
                          }
                      ]
                  },
                  {
                    "width": 1,
                    "height": 0.575,
                    "uom": "meters",
                    "gap": 0.05,
                      "x": 0,
                      "y": 0,
                      "rank": 1,
                      "id": 1238,
                      "reverseRowNumber": 2,
                      "brand": [
                          {
                              "startx": 0,
                              "width": 100,
                              "uom": "cm",
                              "brandName": "coke",
                              "uuid": "001",
                              "mpHasCatHasSubCatHasBrandId": 1,
                              "mpHasCatHasSubCatHasBrandHasRankId": 9,
                              "products": [
                                  {
                                    "id": 12,
                                      "name": "prod 1",
                                      "width": 10,
                                      "height": 20,
                                      "uom": "cm",
                                      "qty": 10,
                                      "startingPoint": 0,
                                      "generatedSpace": 100,
                                      "mpHasCatId": 2,
                                      "mpHasCatHasSubCatId": 2,
                                      "mpHasCatHasSubCatHasBrandId": 1,
                                      "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/1/7290104570162/801172_W100_100.jpg"
                                  }
                              ]
                          }
                      ]
                  },
                  {
                      "width": 1,
                      "height": 0.575,
                      "uom": "meters",
                      "gap": 0.05,
                      "x": 0,
                      "y": 0,
                      "rank": 1,
                      "id": 1238,
                      "reverseRowNumber": 1,
                      "brand": [
                          {
                              "startx": 0,
                              "width": 100,
                              "uom": "cm",
                              "brandName": "coke",
                              "uuid": "001",
                              "mpHasCatHasSubCatHasBrandId": 1,
                              "mpHasCatHasSubCatHasBrandHasRankId": 10,
                              "products": [
                                  {
                                    "id": 12,
                                      "name": "prod 1",
                                      "width": 10,
                                      "height": 20,
                                      "uom": "cm",
                                      "qty": 10,
                                      "startingPoint": 0,
                                      "generatedSpace": 100,
                                      "mpHasCatId": 2,
                                      "mpHasCatHasSubCatId": 2,
                                      "mpHasCatHasSubCatHasBrandId": 1,
                                      "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/1/7290104570162/801172_W100_100.jpg"
                                  }
                              ]
                          }
                      ]
                  }
              ],
              "fieldCount": 1
          }
      }
  ]
}
export let sampleprodobj = {
    "productImage": [],
    "id": 917,
    "width": 10,
    "height": 19,
    "uom": "cm",
    "depth": 4,
    "barcode": "3574661184159",
    "productSource": "direct",
    "gs1Code": null,
    "posMappingId": null,
    "lastPriceOfProduct": null,
    "productName": " Le petit Marseiliais Reparation",
    "brandName": "-",
    "imageId": 6790,
    "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/1/3574661184159/15tgvTODXtqn6Z2b0FqnN_W100_100.jpg"
}

export let savechangesResObject={
    "mpId":90,
    "changes":[
        {
            "startx": 0,
            "width": 448,
            "uom": "cm",
            "brandName": "coke",
            "uuid": "001",
            "mpHasCatHasSubCatHasBrandId": 1,
            "mpHasCatHasSubCatHasBrandHasRankId": 1,
            "products": [
              
                {
                    "id": 1,
                    "name": "prod 1",
                    "width": 10,
                    "height": 20,
                    "uom": "cm",
                    "qty": 4,
                    "startingPoint": 0,
                    "generatedSpace": 400,
                    "mpHasCatId": 1,
                    "mpHasCatHasSubCatId": 1,
                    "mpHasCatHasSubCatHasBrandId": 1,
                    "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/11/12312312312/nRvibXPdeg9E40aCjHxDa_W100_100.jpg"
                },
                {
                    "id": 40,
                    "name": "",
                    "width": 10,
                    "height": 0,
                    "uom": "cm",
                    "qty": 0,
                    "startingPoint": 0,
                    "generatedSpace": 400,
                    "mpHasCatId": 1,
                    "mpHasCatHasSubCatId": 1,
                    "mpHasCatHasSubCatHasBrandId": 1,
                    "imageUrl":null,
                    "isEmptySpace" : true
                },
                {
                    "id": 2,
                    "name": "prod 2",
                    "width": 13,
                    "height": 20,
                    "uom": "cm",
                    "qty": 6,
                    "startingPoint": 400,
                    "generatedSpace": 338,
                    "mpHasCatId": 1,
                    "mpHasCatHasSubCatId": 1,
                    "mpHasCatHasSubCatHasBrandId": 1,
                    "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/11/01010121021105210241/-7gj0VaCt2RQPc-B6E2yB_W100_100.png"
                }
            ]
        },
        {
            "startx": 758,
            "width": 740,
            "uom": "cm",
            "brandName": "pesi",
            "uuid": "002",
            "mpHasCatHasSubCatHasBrandId": 2,
            "mpHasCatHasSubCatHasBrandHasRankId": 2,
            "products": [
                {
                    "id": 4,
                    "name": "prod 11",
                    "width": 20,
                    "height": 10,
                    "uom": "cm",
                    "qty": 7,
                    "startingPoint": 738,
                    "generatedSpace": 740,
                    "mpHasCatId": 1,
                    "mpHasCatHasSubCatId": 1,
                    "mpHasCatHasSubCatHasBrandId": 2,
                    "imageUrl": "https://d3ginyfiwc1r8i.cloudfront.net/main/11/45615611051561165/RoBQ9GVONozxWqTuAqXNd_W100_100.png"
                }
            ]
        }
    ]
}

